import { Application } from "@hotwired/stimulus"
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"


const application = Application.start()

// Load all the controllers from the /controllers folder and all its subdirectories.
// eagerLoadControllersFrom("controllers", application)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
